/* Open desktop mega-menu panels on hover (mouse users only).
   Touch and keyboard keep Shopify's default click/focus behaviour. */
(function () {
  var mq = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');

  function wire(menu) {
    var details = menu.querySelector('details');
    if (!details || menu.dataset.slHover) return;
    menu.dataset.slHover = '1';
    var summary = details.querySelector('summary');
    var timer;

    function open() {
      if (!mq.matches) return;
      clearTimeout(timer);
      if (!details.open) {
        details.setAttribute('open', '');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      }
    }
    function close() {
      if (!mq.matches) return;
      timer = setTimeout(function () {
        details.removeAttribute('open');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }, 250);
    }

    menu.addEventListener('mouseenter', open);
    menu.addEventListener('mouseleave', close);

    /* A click while hover-opened would otherwise toggle the panel shut. */
    if (summary) {
      summary.addEventListener('click', function (e) {
        if (mq.matches && details.open) e.preventDefault();
      });
    }
  }

  function init() {
    document.querySelectorAll('header-menu').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
